import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'callbackFilter',
  standalone: true
})
export class CallbackFilterPipe implements PipeTransform {

  transform<T>(items: T[], callback: (item: T) => boolean): T[] {
    if(!items || !callback) {
      return items
    }
    return items.filter(item => callback(item));
  }

}
